module.exports = __webpack_public_path__ + "static/media/char_kway_teow_1.212ff81f.png";